"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// All general words from the ESN project
var General = {
  we_are_sorry: {
    nl: "Het spijt ons!",
    fr: "Nous sommes désolés!",
    en: "We're sorry!"
  },
  enterprise_cannot_be_found_anymre: {
    nl: "Deze onderneming is niet meer te vinden",
    fr: "Cette entreprise est introuvable",
    en: "This enterprise cannot be found anymore"
  },
  redirecting_you_to_home: {
    nl: "U wordt omgeleid naar de home pagina..",
    fr: "Rediriger vers la page d'accueil..",
    en: "Redirecting you to home.."
  },
  go_back_to_home: {
    nl: "Terug naar home pagina",
    fr: "Retourner à l'accueil",
    en: "Go back to home"
  },
  back: {
    nl: "Terug",
    fr: "Retourner",
    en: "Back"
  },
  esn: {
    nl: 'osn',
    fr: 'rse',
    en: 'esn'
  },
  user: {
    nl: 'gebruiker',
    fr: 'utulisateur',
    en: 'user'
  },
  dutch: {
    nl: 'Nederlands',
    fr: 'Néerlandais',
    en: 'Dutch'
  },
  french: {
    nl: 'Frans',
    fr: 'Français',
    en: 'French'
  },
  english: {
    nl: 'Engels',
    fr: 'Anglais',
    en: 'English'
  },
  lang_short: {
    nl: 'nl',
    fr: 'fr',
    en: 'en'
  },
  group: {
    nl: 'Groep',
    fr: 'Groupe',
    en: 'Group'
  },
  not_group: {
    nl: 'Niet groep',
    fr: 'Pas de groupe',
    en: 'not group'
  },
  group_connections: {
    nl: 'Groepskoppelingen',
    fr: 'Connexions de groupe',
    en: 'Group connections'
  },
  groups: {
    nl: 'Groepen',
    fr: 'Groupes',
    en: 'Groups'
  },
  all_groups: {
    nl: 'Alle groepen',
    fr: 'Toutes les groupes',
    en: 'All groups'
  },
  cread: {
    nl: 'CREAD',
    fr: 'CREAD',
    en: 'CREAD'
  },
  creads: {
    nl: 'CREADs',
    fr: 'CREADs',
    en: 'CREADs'
  },
  all_creads: {
    nl: 'Alle CREADs',
    fr: 'Toutes les CREADs',
    en: 'All CREADs'
  },
  pages: {
    nl: "Pagina's",
    fr: 'Pages',
    en: 'Pages'
  },
  icon: {
    nl: 'Icoon',
    fr: 'Icône',
    en: 'Icon'
  },
  icons: {
    nl: 'Iconen',
    fr: 'Icônes',
    en: 'Icons'
  },
  media: {
    nl: 'Media',
    fr: 'Médias',
    en: 'Media'
  },
  media_files: {
    nl: 'Media / bestand',
    fr: 'Média / fichier multimédia',
    en: 'Media / file'
  },
  search: {
    nl: 'Zoek naar',
    fr: 'Chercher',
    en: 'Search'
  },
  search_slug: {
    nl: 'zoeken',
    fr: 'chercher',
    en: 'search'
  },
  search_slug_2: {
    nl: 'zoeken-in',
    fr: 'rechercher-a',
    en: 'search-in'
  },
  search_in_slug: {
    nl: 'zoeken-in',
    fr: 'rechercher-a',
    en: 'search-in'
  },
  search_filters: {
    nl: 'Zoekfilters',
    fr: 'Filtres',
    en: 'Searchfilters'
  },
  search_with_filters: {
    nl: 'Zoeken met filters',
    fr: 'Recherche avec filtres',
    en: 'Search with filters'
  },
  "in": {
    nl: 'in',
    fr: 'à',
    en: 'in'
  },
  search_dots: {
    nl: 'Zoek naar...',
    fr: 'Chercher...',
    en: 'Search...'
  },
  search_and_add: {
    nl: 'Zoek en voeg toe...',
    fr: 'Rechercher et ajouter...',
    en: 'Search and add...'
  },
  profile_settings: {
    nl: 'Profiel instellingen',
    fr: 'Paramètres profil',
    en: 'Profile settings'
  },
  history: {
    nl: 'Geschiedenis',
    fr: 'Histoire',
    en: 'History'
  },
  notifications: {
    nl: 'Notificaties',
    fr: 'Les notifications',
    en: 'Notifications'
  },
  colleagues: {
    nl: "Collega's",
    fr: 'Collègues',
    en: 'Colleagues'
  },
  management: {
    nl: 'Beheer',
    fr: 'Administration',
    en: 'Management'
  },
  export_data: {
    nl: 'Exporteer gegevens',
    fr: 'Exporter des données',
    en: 'Export data'
  },
  add: {
    nl: 'Voeg toe',
    fr: 'Ajouter',
    en: 'Add'
  },
  media_library: {
    nl: 'Media bibliotheek',
    fr: 'Médiathèque',
    en: 'Media library'
  },
  all_icons: {
    nl: 'Alle iconen',
    fr: 'Toutes les icones',
    en: 'All icons'
  },
  all_media: {
    nl: 'Alle media',
    fr: 'Tous les médias',
    en: 'All media'
  },
  active: {
    nl: 'Actief',
    fr: 'Actif',
    en: 'Active'
  },
  is_active: {
    nl: 'Actief',
    fr: 'Actif',
    en: 'Active'
  },
  start_date: {
    nl: 'Begindatum',
    fr: 'Date de début',
    en: 'Start date'
  },
  end_date: {
    nl: 'Einddatum',
    fr: 'Date de fin',
    en: 'End date'
  },
  entity: {
    nl: 'Entiteit',
    fr: 'Entité',
    en: 'Entity'
  },
  update_date: {
    nl: 'Geüpdatet op',
    fr: 'Date mis à jour',
    en: 'Updated on'
  },
  created_date: {
    nl: 'Aanmaakdatum',
    fr: 'Date de création',
    en: 'Created date'
  },
  entity_info: {
    nl: 'Informatie over entiteit',
    fr: "Information d'entité",
    en: 'Entity information'
  },
  edit: {
    nl: 'Bewerk',
    fr: 'Éditer',
    en: 'Edit'
  },
  settings: {
    nl: 'Instellingen',
    fr: 'Paramètres',
    en: 'Settings'
  },
  draft: {
    nl: 'Klad',
    fr: 'Brouillon',
    en: 'Draft'
  },
  logo: {
    nl: 'Logo',
    fr: 'Logo',
    en: 'Logo'
  },
  name: {
    nl: 'Naam',
    fr: 'Nom',
    en: 'Name'
  },
  description: {
    nl: 'Beschrijving',
    fr: 'Description',
    en: 'Description'
  },
  no_description: {
    nl: 'Geen beschrijving',
    fr: 'Pas de description',
    en: 'No description'
  },
  describe_group: {
    nl: 'Beschrijf deze groep',
    fr: 'Décrire ce groupe',
    en: 'Describe this group'
  },
  confirm: {
    nl: 'Bevestigen',
    fr: 'Confirmer',
    en: 'Confirm'
  },
  delete_all: {
    nl: 'Verwijder alles',
    fr: 'Effacer tout',
    en: 'Remove all'
  },
  advanced_search: {
    nl: 'Geavanceerd zoeken',
    fr: 'Recherche avancée',
    en: 'Advanced search'
  },
  search_options: {
    nl: 'Zoekopties',
    fr: 'Options de recherche',
    en: 'Search options'
  },
  no_current_offers: {
    nl: 'Er zijn geen huidige aanbiedingen',
    fr: "Il n'y a pas d'offres a montrer",
    en: 'There are no current offers'
  },
  current_offers: {
    nl: 'Huidige aanbiedingen',
    fr: 'Offres actuelles',
    en: 'Current offers'
  },
  our_story: {
    nl: 'Ons verhaal',
    fr: 'Notre histoire',
    en: 'Our story'
  },
  in_the_picture: {
    nl: 'In de kijker',
    fr: "Mettre à l'honneur",
    en: 'In the picture'
  },
  business_page: {
    nl: 'Bedrijfspagina',
    fr: "Page d'entreprise",
    en: 'Business page'
  },
  video_library: {
    nl: 'Video bibliotheek',
    fr: 'Vidéothèque',
    en: 'Video library'
  },
  videos: {
    nl: "Video's",
    fr: 'Vidéos',
    en: 'Videos'
  },
  video: {
    nl: "Video",
    fr: 'Vidéo',
    en: 'Video'
  },
  promos_and_catalogues: {
    nl: "Promo's & catalogi",
    fr: 'Promos et catalogues',
    en: 'Promos & catalogues'
  },
  promos_and_magazines: {
    nl: "Promo's & magazines",
    fr: 'Promos et magazines',
    en: 'Promos & magazines'
  },
  promos_magazines: {
    nl: "Promo's & magazines",
    fr: 'Promos et magazines',
    en: 'Promos & magazines'
  },
  info_and_magazines: {
    nl: "Info en magazines",
    fr: 'Infos et magazines',
    en: 'Info and magazines'
  },
  brands: {
    nl: 'Merken',
    fr: 'Marques',
    en: 'Brands'
  },
  brand: {
    nl: 'Merk',
    fr: 'Marque',
    en: 'Brand'
  },
  manufacturers: {
    nl: 'Fabrikanten',
    fr: 'Fabricants',
    en: 'Manufacturers'
  },
  manufacturer: {
    nl: 'Fabrikant',
    fr: 'Fabricant',
    en: 'Manufacturer'
  },
  activites_and_services: {
    nl: 'Activiteiten & diensten',
    fr: 'Activités et services',
    en: 'Activities & services'
  },
  activities: {
    nl: 'Activiteiten',
    fr: 'Activités',
    en: 'Activities'
  },
  news_articles: {
    nl: 'Nieuwsartikelen',
    fr: 'Articles de presse',
    en: 'News Articles'
  },
  news_article: {
    nl: 'Nieuwsartikel',
    fr: 'Article de presse',
    en: 'News Article'
  },
  back_to_results: {
    nl: 'Terug naar resultaten',
    fr: 'Retour aux résultats',
    en: 'Back to results'
  },
  how_do_we_protect: {
    nl: 'Hoe beschermen wij jouw privacy?',
    fr: 'Comment protégeons-nous vos données?',
    en: 'How do we protect your privacy?'
  },
  support: {
    nl: 'Support',
    fr: 'Assistance',
    en: 'Support'
  },
  privacy_policy: {
    nl: 'Privacybeleid',
    fr: 'Charte de confidentialité',
    en: 'Privacy policy'
  },
  terms_and_conditions: {
    nl: 'Algemene voorwaarden',
    fr: 'Conditions générales',
    en: 'Terms & Conditions'
  },
  of: {
    nl: 'van',
    fr: 'de',
    en: 'of'
  },
  "with": {
    nl: 'met',
    fr: 'avec',
    en: 'with'
  },
  result: {
    nl: 'resultaat',
    fr: 'résultat',
    en: 'result'
  },
  results: {
    nl: 'resultaten',
    fr: 'résultats',
    en: 'results'
  },
  discover_more: {
    nl: 'Ontdek meer',
    fr: 'Découvrez plus',
    en: 'Discover more'
  },
  visit_site: {
    nl: 'Bezoek website',
    fr: 'Visitez notre site',
    en: 'Visit site'
  },
  your_search_results: {
    nl: 'Jouw zoekresultaten | Ondernemers & Shoppingnetwerk',
    fr: 'Vos résultats de recherche | Réseau Shopping & Entrepreneurs',
    en: 'Your search results | Entrepreneurs & Shoppingnetwork'
  },
  unknown_error: {
    nl: 'Er ging iets mis! Het ligt niet aan jou maar aan ons',
    fr: "Quelque chose s'est mal passé! Ce n'est pas à vous mais à nous",
    en: "Something went wrong! It's not you; it's us"
  },
  cant_find_results: {
    nl: 'Sorry! Er konden geen resultaten worden gevonden',
    fr: "Désoler! Aucun résultat n'a pu être trouvé",
    en: 'Sorry! No results could be found'
  },
  page: {
    nl: 'Pagina',
    fr: 'Page',
    en: 'Page'
  },
  firstname: {
    nl: 'Voornaam',
    fr: 'Prénom',
    en: 'First name'
  },
  lastname: {
    nl: 'Achternaam',
    fr: 'Nom',
    en: 'Last name'
  },
  how_to_bookmark: {
    nl: 'Druk op CTRL + D om toe te voegen aan bladwijzers',
    fr: 'Appuyez sur CTRL + D pour ajouter aux favoris',
    en: 'Press CTRL + D to add to bookmarks'
  },
  entrepreneur: {
    nl: 'Ondernemer',
    fr: 'Entrepreneur',
    en: 'Entrepreneur'
  },
  title: {
    nl: 'Title',
    fr: 'Titre',
    en: 'Title'
  },
  duration: {
    nl: 'Looptijd',
    fr: 'La durée',
    en: 'Duration'
  },
  am_sure: {
    nl: 'Ik ben zeker!',
    fr: 'Je suis sure!',
    en: 'I\'m sure!'
  },
  changed_my_mind: {
    nl: 'Ben van gedacht veranderd',
    fr: 'J\'ai changé d\'avis',
    en: 'I\ve changed my mind'
  },
  sure_you_want_to_delete: {
    nl: 'Ben je zeker dat je dit wilt verwijderen?',
    fr: 'Voulez-vous vraiment supprimer cela?',
    en: 'Are you sure you want to delete this?'
  },
  from: {
    nl: 'Van',
    fr: 'De',
    en: 'From'
  },
  to: {
    nl: 'Tot',
    fr: 'à',
    en: 'To'
  },
  no_linked: {
    nl: 'Geen gekoppelde',
    fr: 'Pas de lien',
    en: 'No linked'
  },
  selected: {
    nl: 'Geselecteerde',
    fr: 'Sélectionné',
    en: 'Selected'
  },
  esn_name: {
    nl: 'Ondernemers & Shoppingnetwerk',
    fr: 'Réseau Shopping & Entrepreneurs',
    en: 'Entrepreneurs & Shoppingnetwork'
  },
  esn_description: {
    nl: 'Als meest privacyvriendelijke en relevante zoekmachine biedt het ondernemersnetwerk jou alle Belgische ondernemers in één netwerk aan.',
    fr: "En tant que moteur de recherche le plus adapter à votre recherche et le plus respectueux de la vie privée, le Réseau Entrepreneurs vous propose tous les entrepreneurs Belges d'un même réseau.",
    en: 'As the most privacy friendly and relevant search engine, the Entrepreneurnetwork offers you all Belgian entrepreneurs in one network.'
  },
  search_engine: {
    nl: 'Zoekmachine',
    fr: 'Moteur de recherche',
    en: 'Search engine'
  },
  esn_alt: {
    nl: 'Logo Ondernemersnetwerk',
    fr: 'Logo Réseau d’Etrepreneurs',
    en: 'Logo Entrepreneursnetwork'
  },
  cn_alt: {
    nl: 'Logo Catalogusnetwerk',
    fr: 'Logo Réseau Catalogue',
    en: 'Logo Catalogue network'
  },
  pn_alt: {
    nl: 'Logo Promonetwerk',
    fr: 'Logo Réseau Promo',
    en: 'Logo Promo network'
  },
  networks: {
    nl: 'Alle netwerken',
    fr: 'Tout nos réseaux',
    en: 'All networks'
  },
  lang_menu_0: {
    nl: 'Nederlands',
    fr: 'Français',
    en: 'English'
  },
  search_engine_desc: {
    nl: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Meest ", /*#__PURE__*/_react["default"].createElement("strong", null, "privacyvriendelijke"), " en relevante zoekresultaten van ", /*#__PURE__*/_react["default"].createElement("strong", null, "alle Belgische ondernemers")),
    fr: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Le moteur de recherche ", /*#__PURE__*/_react["default"].createElement("strong", null, "le plus confidentiel"), " avec des r\xE9sultats adapter \xE0 votre recherche ", /*#__PURE__*/_react["default"].createElement("strong", null, "des entrepreneurs Belge")),
    en: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Most ", /*#__PURE__*/_react["default"].createElement("strong", null, "privacy-friendly"), " and relevant search results ", /*#__PURE__*/_react["default"].createElement("strong", null, "of all Belgian entrepreneurs"))
  },
  search_engine_desc_local: {
    nl: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Meest ", /*#__PURE__*/_react["default"].createElement("strong", null, "privacyvriendelijke"), " en relevante zoekresultaten van ", /*#__PURE__*/_react["default"].createElement("strong", null, "alle lokale ondernemers in")),
    fr: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Le moteur de recherche ", /*#__PURE__*/_react["default"].createElement("strong", null, "le plus confidentiel"), " avec des r\xE9sultats pertinants ", /*#__PURE__*/_react["default"].createElement("strong", null, "des entrepreneurs locaux \xE0")),
    en: /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Most ", /*#__PURE__*/_react["default"].createElement("strong", null, "privacy-friendly"), " and relevant search results ", /*#__PURE__*/_react["default"].createElement("strong", null, "of all local entrepreneurs in"))
  },
  local_enterprises: {
    nl: 'Lokale ondernemingen in',
    fr: 'Entreprises locales à',
    en: 'Local enterprises in'
  },
  my_company: {
    nl: 'Mijn bedrijf',
    fr: 'Mon enterprise',
    en: 'My company'
  },
  cookies_message: {
    nl: /*#__PURE__*/_react["default"].createElement("div", null, "Wij gebruiken cookies om uw laatste zoekresultaten te tonen. ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), " Wanneer u accepteert is dit de enige cookie die wij voor uw gebruiksgemak opslaan in uw browser."),
    fr: /*#__PURE__*/_react["default"].createElement("div", null, "Nous utilisons des cookies pour afficher vos derniers r\xE9sultats de recherche. ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), " Si vous l'acceptez, c'est le seul cookie que nous stockons dans votre navigateur pour votre facilit\xE9 d'utilisation.."),
    en: /*#__PURE__*/_react["default"].createElement("div", null, "We use cookies to display your latest search results. ", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), " If you accept, this is the only cookie we store in your browser for your ease of use.")
  },
  cookies_1: {
    nl: "We gebruiken cookies om u uw laatste zoekresultaten te tonen.",
    fr: "Nous utilisons des cookies pour vous montrer vos derniers résultats de recherche.",
    en: "We use cookies to show you your latest search results."
  },
  cookies_2: {
    nl: "Uw voorkeur (geaccepteerd of geweigerd) is de enige noodzakelijke cookie die in uw browser wordt opgeslagen.",
    fr: "Votre préférence (acceptée ou refusée) est le seul cookie nécessaire enregistré dans votre navigateur.",
    en: "Your preference (accepted or refused) is the only necessary cookie saved in your browser."
  },
  accept: {
    nl: "Accepteer",
    fr: "Accepter",
    en: "Accept"
  },
  refuse: {
    nl: "Weigeren",
    fr: "Refuser",
    en: "Refuse"
  },
  yes_message: {
    nl: "Ja",
    fr: "Oui",
    en: "Yes"
  },
  no_message: {
    nl: "Nee",
    fr: "Non",
    en: "No"
  },
  of_the: {
    nl: "Van de",
    fr: "Du",
    en: "Of"
  },
  reCaptcha: {
    nl: "Kan niet valideren",
    fr: "Impossible de valider",
    en: "Failed to validate"
  },
  opening_hours_check: {
    nl: "Even geduld, We kijken de openingsuren van dit bedrijf na !",
    fr: "Veuillez patienter, nous vérifions les heures d'ouverture sur cette entreprise !",
    en: "Hold on, while we are checking the openinghours of this enterprise !"
  },
  percent_local: {
    nl: "100procentlokaal",
    fr: "100pourcentlocale",
    en: "100percentlocal"
  },
  contact_url: {
    nl: "contact",
    fr: "contact",
    en: "contact"
  },
  current_offers_url: {
    nl: "huidige-aanbiedingen",
    fr: "offres-actuelles",
    en: "current-offers"
  },
  our_story_url: {
    nl: 'ons-verhaal',
    fr: 'notre-histoire',
    en: 'our-story'
  },
  videos_url: {
    nl: "videos",
    fr: "videos",
    en: "videos"
  },
  digital_display_url: {
    nl: "promos-magazines",
    fr: "promos-magazines",
    en: "promos-magazines"
  },
  brands_url: {
    nl: "merken",
    fr: "marques",
    en: "brands"
  },
  activities_url: {
    nl: "activiteiten",
    fr: "activités",
    en: "activities"
  },
  message_from: {
    nl: "Bericht van",
    fr: "message de",
    en: "Message from"
  },
  valid_until: {
    nl: "Geldig tot",
    fr: "Valable jusqu'au",
    en: "Valid until"
  },
  read_more: {
    nl: "Lees meer",
    fr: "Plus d'info",
    en: "Read more"
  },
  go_to: {
    nl: 'Ga naar',
    fr: 'Allez sur',
    en: 'Go to'
  },
  this_city_is_not_sharing_its_books_here_yet: {
    nl: 'Deze stad deelt haar boekjes hier nog niet',
    fr: 'Cette ville ne partage pas encore ses livres ici',
    en: 'This city is not sharing its books here yet'
  },
  this_municipality_is_not_sharing_its_books_here_yet: {
    nl: 'Deze gemeente deelt haar boekjes hier nog niet',
    fr: 'Cette commune ne partage pas encore ses livres ici',
    en: 'This municipality is not sharing its books here yet'
  },
  search_for_all_enterprises: {
    nl: 'Zoek naar alle handelaars en ondernemers van',
    fr: 'Recherchez tous les commerçants et entrepreneurs de',
    en: 'Search for all traders and entrepreneurs of'
  },
  search_for_all_enterprises_main: {
    nl: 'Zoek naar alle handelaars en ondernemers ...',
    fr: 'Recherchez tous les commerçants et entrepreneurs ...',
    en: 'Search for all traders and entrepreneurs ...'
  },
  follow: {
    nl: 'Volgen',
    fr: 'Suivre',
    en: 'Follow'
  },
  cookie_mc_1: {
    nl: 'Wij gebruiken alleen cookies om bij te houden of dit bericht al is weergegeven',
    fr: 'Nous utilisons uniquement des cookies pour savoir si ce message a déjà été affiché',
    en: 'We only use cookies to keep track of whether this message has already been displayed'
  },
  cookie_mc_2: {
    nl: 'Wanneer u accepteert is dit de enige cookie die wij opslaan in uw browser.',
    fr: "Lorsque vous acceptez, c'est le seul cookie que nous stockons dans votre navigateur.",
    en: 'When you accept, this is the only cookie we store in your browser.'
  },
  your_city_or_municipality_has_a_lot_to_tell_you: {
    nl: 'Uw stad of gemeente heeft u veel te vertellen en zij deelt dit graag met haar bewoners. Regelmatig verschijnt er dan ook een info- magazine met heel wat nuttige informatie.',
    fr: 'Votre ville ou commune a beaucoup à vous dire et elle est heureuse de partager cela avec ses habitants. Un magazine d’information est donc régulièrement publié avec beaucoup d’informations utiles.',
    en: 'Your city or municipality has a lot to tell you and it is happy to share this with its residents. An information magazine is therefore regularly published with a lot of useful information.'
  },
  do_you_also_want_to_stay_informed: {
    nl: 'Wil jij ook op de hoogte blijven wanneer jouw stad of gemeente nieuwe info publiceert? Maak een persoonlijk account aan om een melding te ontvangen!',
    fr: 'Voulez-vous également rester informé lorsque votre ville ou commune publie de nouvelles informations? Créez un compte personnel pour recevoir une notification!',
    en: 'Do you also want to stay informed when your city or municipality publishes new information? Create a personal account to receive a notification!'
  },
  also_from_an_ecological_point_of_view: {
    nl: 'Ook vanuit een ecologisch stand- punt willen zij u in de toekomst de verspreiding van deze informatie niet alleen aanbieden d.m.v. drukwerk maar ook online op:',
    fr: 'Du point de vue écologique également, ils veulent vous offrir la diffusion de ces informations à l’avenir, non seulement au moyen d’imprimés, mais aussi en ligne à:',
    en: 'Also from an ecological point of view they want to offer you the dissemination of this information in the future not only by means of printed matter but also online at:'
  },
  printing_is_no_longer_the_norm: {
    nl: 'Tegenwoordig is drukwerk ook niet meer de norm. Het is duur, tijdrovend en moeilijker te verspreiden. Eventuele fouten zijn ook niet meer te herstellen. Bij online verspreiding zijn talloze kanalen mogelijk en is alles snel aanpasbaar. Uw stad of gemeente is ervan overtuigd dat zij met de besparing op drukwerk extra acties kunnen ondernemen die de bevolking dient.',
    fr: 'L’impression n’est plus la norme de nos jours. Elle est coûteuse, longue et plus difficile à distribuer. Toute erreur ne peut plus être corrigée. Avec la distribution en ligne, De nombreux canaux sont possibles et tout est rapidement adaptable. Votre ville ou municipalité est convaincue qu’avec les économies sur l’impression, ils peuvent prendre des mesures supplémentaires qui servent la population.',
    en: 'Printing is no longer the norm these days. It is expensive, time consuming and more difficult to distribute. Any errors can no longer be corrected. With online distribution, countless channels are possible and everything is quickly adaptable. Your city or municipality is convinced that with the savings on printing, they can take extra actions that serve the population.'
  },
  search_for_a_promo: {
    nl: 'Zoek naar een promo',
    fr: 'Rechercher une promo',
    en: 'Search for a promo'
  },
  search_for_a_magazine: {
    nl: 'Zoek naar een magazine, catalogus of infoblad',
    fr: "Cherchez un magazine, un catalogue ou une fiche d'information",
    en: 'Search for a magazine, catalogue or info sheet'
  },
  publications: {
    nl: 'Publicaties',
    fr: "Publications",
    en: 'Publications'
  },
  preferred_language: {
    nl: 'Taalvoorkeur',
    fr: 'Préférence de langue',
    en: 'Preferred language'
  },
  email_or_username: {
    nl: 'E-mailadres of gebruikersnaam',
    fr: "E-mail ou nom d'utilisateur",
    en: 'E-mail or username'
  },
  disabled_by: {
    nl: 'Uitgeschakeld door',
    fr: "Désactivé par",
    en: 'Disabled by'
  },
  disabled_by_2: {
    nl: 'ondernemer',
    fr: "l'entrepreneur",
    en: 'enterprise'
  }
};
var _default = General;
exports["default"] = _default;